import { gql } from '@apollo/client'

export default gql`
    fragment adminAttachment on Attachment {
        id
        user {
            id
            email
            firstName
            lastName
        }
        sanitized {
            id
            uploadUrl
            downloadUrl
            fileName
            extension
            mimeType
            sizeInKb
            createdAt
            updatedAt
            deletedAt
        }
        uploadUrl
        downloadUrl
        fileName
        extension
        mimeType
        sizeInKb
        createdAt
    }
`
